import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('modules/ticketing/pages/settings/RootPage'))
const ResolverTeamsPage = lazy(() => import('modules/ticketing/pages/settings/ResolverTeams'))
const TicketCategoriesPage = lazy(() => import('modules/ticketing/pages/settings/TicketCategories'))
const CategoryWorkflowBuilderPage = lazy(() =>
  import('modules/ticketing/pages/settings/CategoryWorkflowBuilder/CategoryWorkflowBuilderPage').then(
    (m) => ({ default: m.CategoryWorkflowBuilderPage })
  )
)
const RedirectToResolverTeams = lazy(
  () => import('modules/ticketing/pages/settings/RedirectToResolverTeams')
)

const ticketingSettingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.ticketing.path,
      element: <RootPage />,
      handle: {
        resource: true,
        meta: () => ({
          title: i18n.t('ticketing.settings.title'),
          subNavigation: [
            {
              index: true,
              title: i18n.t('ticketing.settings.tabs.resolver_teams'),
              href: navigation.settings.ticketing.resolverTeams.fullPath(),
            },
            {
              title: i18n.t('ticketing.settings.tabs.ticket_categories'),
              href: navigation.settings.ticketing.ticketCategories.fullPath(),
            },
          ],
        }),
      },
      children: [
        {
          index: true,
          element: <RedirectToResolverTeams />,
        },
        {
          path: navigation.settings.ticketing.resolverTeams.path,
          element: <ResolverTeamsPage />,
          handle: {
            meta: () => ({
              title: i18n.t('ticketing.settings.tabs.resolver_teams'),
            }),
          },
        },
        {
          path: navigation.settings.ticketing.ticketCategories.path,
          element: <TicketCategoriesPage />,
          handle: {
            meta: () => ({
              title: i18n.t('ticketing.settings.tabs.ticket_categories'),
            }),
          },
        },
        {
          path: `${navigation.settings.ticketing.ticketCategories.path}/:categoryId/workflow`,
          element: <CategoryWorkflowBuilderPage />,
          handle: {
            meta: () => ({
              title: i18n.t('ticketing.workflows.builder.page_title'),
            }),
          },
        },
      ],
    },
  ]
}

export default ticketingSettingsRoutes
